import { render, staticRenderFns } from "./ChangelogAlert.vue?vue&type=template&id=5c445b40"
import script from "./ChangelogAlert.vue?vue&type=script&lang=js"
export * from "./ChangelogAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports